export default "__VITE_ASSET__Uc8MrUiM__"